<template>
  <div class="input-label flex flex-col">
    <label for="input" class="text-base w-1/2">{{ $ctx.locale == 'en' ? setting.enName : setting.arName }}</label>
    <div class="w-full md:w-1/2 lg:w-1/3 flex items-center gap-2">
      <el-select
          v-model="val"
          class="col-span-4 md:col-span-2 lg:col-span-1"
          @change="onChange"
      >
        <el-option v-for="(option, i) in setting.options.options" :key="i" :value="option.value"
                   :label="t(option.label)">
          <span>{{ t(option.label) }}</span>
        </el-option>
      </el-select>
      <QRStylePreview v-if="setting.key === 'examination_qr_image_style'" :selected="val" @select="onPreviewSelect"/>
      <IDCardStylePreview v-if="setting.key === 'examination_id_card_style'" :selected="val" @select="onPreviewSelect"/>
    </div>
  </div>
</template>
<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {nextTick, onBeforeMount, onUnmounted, ref} from "vue";
import {useSettingsStore} from "@/stores/settingsStore";
import QRStylePreview from "@/components/settings/QRStylePreview.vue";
import IDCardStylePreview from "@/components/settings/IDCardStylePreview.vue";

const props = defineProps(['setting'])


const messages = {
  en: {},
  ar: {},
}
const {t} = useI18n({messages, useScope: 'global'});
const settingStore = useSettingsStore();

const val = ref();

onBeforeMount(() => {
  val.value = null
  nextTick(() => {
    val.value = props.setting.value
  })
});


function onChange(e: any) {
  settingStore.updateSetting(props.setting.key, props.setting.id, e)
}

function onPreviewSelect(value: string) {
  val.value = value
  onChange(value)
}

</script>
<style scoped>

</style>
